import DocTypeConfig from "../../models/config/DocTypeConfig";

export { DocTypeConfigSelector };

type Props = {
  docTypeConfigs: DocTypeConfig[];
  selected: DocTypeConfig | string;
  onChange: (docTypeConfig: DocTypeConfig) => void;
  enableUnknown?: boolean;
  unknownText?: string;
};

const DocTypeConfigSelector = (props: Props) => {
  const selectedTypeName =
    typeof props.selected === "object"
      ? props.selected.typeName
      : props.selected;
  const docTypes = [...props.docTypeConfigs].sort((a, b) => {
    const aUnknown = a.typeName === "Unknown";
    const bUnknown = b.typeName === "Unknown";

    if (aUnknown && !bUnknown) return 1;
    if (!aUnknown && bUnknown) return -1;

    const aPos = a?.helios?.position;
    const bPos = b?.helios?.position;

    if (aPos == null && bPos == null) return 0;
    if (aPos == null) return 1;
    if (bPos == null) return -1;

    return aPos - bPos;
  });

  return (
    <select
      value={selectedTypeName}
      data-unknown={selectedTypeName === DocTypeConfig.UNKNOWN_NAME}
      onChange={(e) => {
        const docTypeConfig = props.docTypeConfigs.find(
          (x) => x.typeName === e.target.value,
        );
        if (!docTypeConfig || (docTypeConfig.unknown && !props.enableUnknown)) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        props.onChange(docTypeConfig);
      }}
    >
      {docTypes.map((d) => (
        <option
          key={d.typeName}
          value={d.typeName}
          label={
            d.unknown
              ? (props.unknownText ?? d.typeName)
              : (d.description ?? d.typeName)
          }
          disabled={props.enableUnknown ? false : d.unknown}
        >
          {d.description ?? d.typeName}
        </option>
      ))}
    </select>
  );
};
